import { SITE } from './seoContent';

// ItemList structured data so search engines see every model on a category page.
export const itemListLd = (name, path, items) => ({
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  name,
  url: SITE + path,
  numberOfItems: items.length,
  itemListElement: items.map((it, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: `${it.brand ? it.brand + ' ' : ''}${it.name}`,
    url: it.url ? SITE + it.url : `${SITE}${path}`,
    ...(it.image ? { image: it.image.startsWith('http') ? it.image : SITE + it.image } : {}),
  })),
});

export const spaButlerLd = (plans) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Spa Butler Hot Tub Cleaning, Maintenance & Repair',
  serviceType: 'Hot tub cleaning, maintenance and repair',
  description: 'Hot tub water care plans with chemicals included and a 32-point inspection every visit. No long-term contract. Standard residential spas within 25 miles of the Naples showroom.',
  provider: { '@id': `${SITE}/#business` },
  areaServed: ['Naples, FL', 'Marco Island, FL', 'Bonita Springs, FL', 'Estero, FL'],
  url: `${SITE}/spa-butler`,
  offers: plans.map((p) => ({
    '@type': 'Offer',
    name: `${p.plan} plan — ${p.visits}`,
    price: p.price.replace(/[^0-9.]/g, ''),
    priceCurrency: 'USD',
    priceSpecification: { '@type': 'UnitPriceSpecification', price: p.price.replace(/[^0-9.]/g, ''), priceCurrency: 'USD', unitText: 'month' },
  })),
});
